<template>
  <v-card>
    <v-dialog
      v-model="isDataLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>Please Stand By
          <br>
          {{message}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card-title>
      <v-toolbar-title>
        <slot />
      </v-toolbar-title>
    </v-card-title>
    
    <v-layout class="py-2" row wrap> 
      <v-flex xs12 md6>
        <v-layout row wrap> 
          <v-flex xs6>
            <v-btn color="primary" @click="exportCsv">Download CSV</v-btn>
          </v-flex>
          <v-flex xs4>
            <v-select
              :items="pageOptions"
              item-text="text"
              item-value="value"
              label="Page Size"
              v-model="pageSize"
              @change="onPageSizeChanged"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md6>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-flex>
    </v-layout>
    <div style="width: 100%; flex: 1 1 auto;">
      <ag-grid-vue
        style="width: 100%; height: 100%"
        domLayout="autoHeight"
        class="ag-theme-alpine"
        pagination
        :columnDefs="columnDefs"
        :rowData="commissions"
        :defaultColDef="defaultColDef"
        :paginationPageSize="pageSize"
        :frameworkComponents="frameworkComponents"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
      ></ag-grid-vue>
    </div>
    <!-- <v-data-table
      :headers="headers"
      :items="commissions"
      class="elevation-1"
      item-key="id"
      :pagination.sync="pagination"
      :search="search"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td class="text-xs-right">
          {{props.item.runID}}
        </td>
        <td class="text-xs-right">
          ${{props.item.amount | currency}}
        </td>
        <td class="text-xs-right">{{props.item.runDate | formatDate}}</td>
        <td class="justify-center layout px-0">
          <v-btn
            icon
            class="mx-0"
            title="download"
            @click="download(props.item['runID'])"
          >
            <v-icon color="teal">cloud_download</v-icon>
          </v-btn>
          <feature name="feature1">
            <v-btn
              icon
              class="mx-0"
              title="email to administrator"
              @click="email(props.item['runID'])"
            >
              <v-icon color="teal">email</v-icon>
            </v-btn>
          </feature>
        </td>
      </template>
    </v-data-table> -->
  </v-card>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import { createNamespacedHelpers } from "vuex";
import moment from "moment";
import ActionButton from './action-button.vue';

const { mapActions: mapCommissionsActions } = createNamespacedHelpers(
  `commissions`
);

const { mapActions: mapDealerActions } = createNamespacedHelpers(`dealer`);

import globalMixin from "@/mixins/globalMixin";
export default {
	mame: "EmployeeCommissions",
	props: {
		employee: {
			type: Object,
			required: true
		},
		runType: {
			type: Number,
			required: true
		}
	},
  components: {
    AgGridVue,
  },
	mixins: [globalMixin],
	data () {
		return {
			cQuery: {},
			message: null,
			isDataLoading: false,
			pagination: {
				descending: true
			},
			commissions: [],
			headers: [
				{
					descending: true,
					text: "Run ID",
					value: "runID",
					align: "right",
					sortable: true
				},
				{
					text: "Amount",
					value: "amount",
					align: "right",
					sortable: true
				},
				{
					text: "Date Issued",
					value: "runDate",
					align: "right",
					sortable: false
				},
				{
					text: "Actions",
					value: "name",
					align: "center",
					sortable: false
				}
			],
      search: '',
      gridOptions: null,
      columnDefs: null,
      defaultColDef: null,
      gridApi: null,
      columnApi:null,
      frameworkComponents: null,
      pageSize: 10,
      pageOptions: [
        {
          text: 10,
          value: 10
        },
        {
          text: 20,
          value: 20
        },
        {
          text: 50,
          value: 50
        },
        {
          text: 'All',
          value: -1
        },
      ]
		};
	},
	computed: {},
  watch: {
    search(val) {
      if (val) this.gridApi.setQuickFilter(val)
    },
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: 'Run ID',
        field: 'runID',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Amount',
        field: 'amount',
        sortable: true,
        filter: true,
        valueFormatter: (params) => {
          return `$${vm.formatMoney(params.value)}`
        }
      },
      {
        headerName: 'Date Issued',
        field: 'runDate',
        sortable: true,
        filter: true,
        valueFormatter: (params) => {
          return moment(String(params.value)).format("DD/MM/YYYY")
        }
      },
      {
        headerName: "Actions",
        cellRenderer: "actionButton",
        width: 110,
        suppressSizeToFit: true,
        cellRendererParams: {
          clicked: function (param) {
            vm.download(param.runID)
          },
        },
      },
    ];
    vm.frameworkComponents = {
      actionButton: ActionButton,
    };
    vm.defaultColDef = {
      autoHeight: true,
    };
  },
	mounted () {
		let vm = this;

		vm.getDealer().then(x => {

			vm.cQuery = {
				dealerID: x.dealerID,
				runType: vm.runType,
				numResults: 25,
				showOnlyApproved: true
			}

			vm.$nextTick(() => {
				vm.getCommissions(vm.cQuery)
					.then(data => (vm.commissions = data))
					.catch(() => { });
			});

		});

	},
	methods: {
		...mapDealerActions(["getDealer"]),
		...mapCommissionsActions([
			"getCommissions",
			"downloadCommissions",
			"emailCommissions"
		]),
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      params.api.setDomLayout('autoHeight')
      params.api.sizeColumnsToFit();
    },
     onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onPageSizeChanged() {
      let vm = this
      var pageSize = vm.pageSize == -1 ? vm.commissions.length : vm.pageSize
      vm.gridApi.paginationSetPageSize(pageSize);
      this.gridApi.setDomLayout('autoHeight')
    },
    exportCsv() {
      this.gridApi.exportDataAsCsv()
    },
		download (request) {
			let vm = this;

			vm.message = "Commisisons Report being fetched.";
			vm.isDataLoading = true;
			vm.downloadCommissions({
				runType: vm.cQuery.runType,
				runID: request,
				dealerID: vm.cQuery.dealerID
			})
				.then(() => {
					vm.message = null;
					vm.isDataLoading = false;
				})
				.catch(() => {
					vm.message = null;
					vm.isDataLoading = false;
				});
		},
		email (request) {
			let vm = this;
			vm.message = "Commisisons Report being emailed.";
			vm.isDataLoading = true;
			this.emailCommissions({
				runType: this.cQuery.runType,
				runID: request,
				dealerID: this.cQuery.dealerID
			})
				.then(() => {
					vm.message = null;
					vm.isDataLoading = false;
				})
				.catch(() => {
					vm.message = null;
					vm.isDataLoading = false;
				});
		},
    formatMoney (n) {
      var c = isNaN((c = Math.abs(c))) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(2)))),
        j = (j = i.length) > 3 ? j % 3 : 0;

      return (
        s +
        (j ? i.substr(0, j) + t : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
        (c
          ? d +
          Math.abs(n - i)
            .toFixed(c)
            .slice(2)
          : "")
      );
    }
	}
};
</script>

<style scoped>
</style>
